import { PaginationParty } from "../../generated/graphql";
import { PARTY_SUCCESS } from "../action/party.action";

export const partyActionSuccess = (payload: PaginationParty) => {
  return {
    type: PARTY_SUCCESS,
    payload,
  };
};
